<template>
  <div class="sistem-ayarlar-view">
    <AppMain>
      <div class="container">
        <div class="page-title-container">
          <div class="row">
            <div class="col-12 col-md-8">
              <h1 class="mb-0 pb-0 display-4">Sistem Ayarlar</h1>
              <nav class="breadcrumb-container d-inline-block" aria-label="breadcrumb">
                <ul class="breadcrumb pt-0">
                  <li class="breadcrumb-item">
                    <router-link to="/">Anasayfa</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/sistemayarlar">Sistem Ayarlar</router-link>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="col-12 col-md-4 d-flex align-items-start justify-content-md-end mt-2 mt-md-0">
              <button class="btn btn-outline-danger me-2" @click="varsayilanlaraDon">Varsayilan</button>
              <button class="btn btn-primary" @click="kaydet">Kaydet</button>
            </div>
          </div>
        </div>

        <div class="row g-3">
          <div
            class="col-12 col-md-6 col-xl-4"
            v-for="modul in modulAyarlari"
            :key="modul.key"
          >
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-body">
                <div class="text-muted text-small mb-1">Modul</div>
                <h5 class="mb-3">{{ modul.label }}</h5>
                <label class="form-label text-small text-muted">Sayfada Gosterilecek Kayit</label>
                <select class="form-select" v-model.number="formValues[modul.key]">
                  <option v-for="adet in adetSecenekleri" :key="`${modul.key}-${adet}`" :value="adet">
                    {{ adet }} adet
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppMain>
  </div>
</template>

<script>
import AppMain from "@/components/AppMain.vue";
import {
  DEFAULT_PAGINATION_SETTINGS,
  getAllPaginationSettings,
  resetPaginationSettings,
  setModulePageSize,
} from "@/services/paginationSettings";

export default {
  name: "SistemAyarlarView",
  components: {
    AppMain,
  },
  data() {
    return {
      adetSecenekleri: [5, 10, 15, 20, 30, 40, 50, 75, 100],
      formValues: { ...DEFAULT_PAGINATION_SETTINGS },
      modulAyarlari: [
        { key: "musteriler", label: "Musteriler" },
        { key: "kullanicilar", label: "Kullanicilar" },
        { key: "isler", label: "Isler" },
        { key: "musterinotlar", label: "Musteri Notlari" },
        { key: "yapilacaklar", label: "Yapilacaklar" },
        { key: "fikirler", label: "Is Fikirleri" },
        { key: "roller", label: "Roller" },
        { key: "isturler", label: "Is Turleri" },
        { key: "bildirimler", label: "Bildirimler" },
        { key: "musteriDetayDevamEdenIsler", label: "Musteri Detay - Devam Eden Isler" },
        { key: "musteriDetayTamamlananIsler", label: "Musteri Detay - Tamamlanan Isler" },
        { key: "kullaniciDetayElindekiIsler", label: "Kullanici Detay - Elindeki Isler" },
        { key: "kullaniciDetayTamamlananIsler", label: "Kullanici Detay - Tamamlanan Isler" },
        { key: "elimdekiIsler", label: "Elimdeki Isler" },
      ],
    };
  },
  mounted() {
    this.formValues = getAllPaginationSettings();
  },
  methods: {
    kaydet() {
      this.modulAyarlari.forEach((modul) => {
        setModulePageSize(modul.key, this.formValues[modul.key]);
      });
      this.$toast.success("Sistem ayarlari kaydedildi.");
    },
    varsayilanlaraDon() {
      resetPaginationSettings();
      this.formValues = getAllPaginationSettings();
      this.$toast.success("Varsayilan ayarlara donuldu.");
    },
  },
};
</script>
